import CloseIcon from 'src/images/icons/CloseIcon'

export function PostalCodeModalHeader({ onClose }: { onClose: () => void }) {
  return (
    <header className="relative flex items-start justify-between pb-1 md:pt-6">
      <div>
        <p className="text-font-size-6 leading-tight font-bold text-restructure-primary font-display tracking-[-0.5px]">
          Onde você quer receber?
        </p>
        <p className="mt-[5px] text-sm text-postal-muted leading-snug font-normal">
          Selecione um endereço salvo ou informe um novo CEP.
        </p>
      </div>
      <button
        className="absolute right-0 top-[29px] hidden md:block"
        onClick={onClose}
      >
        <span className="sr-only">Fechar</span>
        <CloseIcon width={18} height={18} />
      </button>
    </header>
  )
}
